<template>
  <div class="check-work-body d-flex">
    <div class="d-flex-left">
      <erp-tree-status-v2 @node-click="nodeClick"></erp-tree-status-v2>
    </div>
    <div class="d-flex-right">
      <div>
        <div class="search-wrap">
          <el-button size="mini" @click="search">查询</el-button>
          <el-button size="mini" @click="navToMeterExcel">导入</el-button>
        </div>

        <div style="margin-bottom: 10px;">
          <el-descriptions :column="2" border size="mini" :labelStyle="{width: '100px'}" :contentStyle="{width:'43%'}">
            <el-descriptions-item label="仪表类型">
              <el-select size="mini" style="width: 100%" v-model="param.meter_type" clearable filterable placeholder="类型" class="kuan">
                <el-option v-for="item in meter_type_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-descriptions-item>
            <el-descriptions-item label="当前房产">
              <el-input size="mini" placeholder="请选择房产" v-model="param.house_name" clearable></el-input>
            </el-descriptions-item>
            <el-descriptions-item label="仪表编号">
              <el-input size="mini" placeholder="请输入仪表编号" v-model="param.number" clearable></el-input>
            </el-descriptions-item>

            <el-descriptions-item label="仪表状态">
              <el-checkbox-group v-model="param.status_ids">
                <el-checkbox v-for="item in [{name:'在用',val:1},{name:'停用',val:2}]" :label="item.val" :key="item.val">{{item.name}}</el-checkbox>
              </el-checkbox-group>
            </el-descriptions-item>

            <el-descriptions-item label="仪表层级">
              <el-input size="mini" placeholder="仪表层级" v-model="param.level" clearable></el-input>
            </el-descriptions-item>

            <el-descriptions-item label="能耗类型">
              <el-checkbox-group v-model="param.energys">
                <el-checkbox v-for="item in [{name:'业主能耗',val:1},{name:'物业能耗',val:2},{name:'业主分摊',val:3},{name:'物业包干制',val:4}]" :label="item.val" :key="item.val">{{item.name}}</el-checkbox>
              </el-checkbox-group>
            </el-descriptions-item>

            <el-descriptions-item label="仪表名称">
              <el-input size="mini" placeholder="请输入仪表名称" v-model="param.name" clearable></el-input>
            </el-descriptions-item>

            <el-descriptions-item label="仪表线路">
              <el-input size="mini" placeholder="请输入仪表线路" v-model="param.line" clearable></el-input>
            </el-descriptions-item>

            <el-descriptions-item label="房产数量">
              <span>{{countData.house_count}}</span>
            </el-descriptions-item>

            <el-descriptions-item label="仪表数量">
              冷水表:{{countData.meter_type_count.water}} &nbsp&nbsp 热水表:{{countData.meter_type_count.hotwater}} &nbsp&nbsp 电表:{{countData.meter_type_count.electricity}}
            </el-descriptions-item>

          </el-descriptions>
        </div>

        <div>
          <el-table v-loading="loading" border :data="pageData.data" width="100%" height="550"  @selection-change="handleSelectionChange">
            <el-table-column type="selection"></el-table-column>
            <el-table-column prop="id" label="id" ></el-table-column>
            <el-table-column prop="house_name" label="房产"></el-table-column>
            <el-table-column prop="meter_type_name" label="仪表类型"></el-table-column>
            <el-table-column prop="number" label="仪表编号 "></el-table-column>
            <el-table-column prop="name" label="仪表名称"></el-table-column>
            <el-table-column prop="level" label="仪表等级"></el-table-column>
            <el-table-column prop="energys_name" label="能耗类型"></el-table-column>
            <el-table-column prop="meter_nature_name" label="仪表性质"></el-table-column>
            <el-table-column prop="energy_nature_name" label="能耗性质"></el-table-column>
            <el-table-column prop="line" label="仪表线路"></el-table-column>


            <el-table-column prop="charging_standard_name" label="收费标准 "></el-table-column>
            <!-- <el-table-column prop="charging_standard_money" label="费用单价 " ></el-table-column> -->
            <el-table-column prop="status" label="是否在用 ">
              <template slot-scope="scope">
                {{scope.row.status?'启用':'停用'}}
              </template>
            </el-table-column>

            <el-table-column prop="id" label="操作">
              <template slot-scope="scope">
                <el-button type="primary" size="mini"  @click="showLine(scope.row)" >查看线路架构</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div style="margin-top: 20px;text-align: right;margin-right: 20px;">
          <Page :total="pageData.total" :current-page="pageData.current_page" :page-size="pageData.per_page" @on-change="getList()" show-total />
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import ErpTree from "../Common/erp-tree";
import UploadFilesSysc from "../Contract/components/UploadFilesSysc";
import ErpTreeStatusV2 from "../Common/erp-tree-status-v2";
import MapSearch from "../Common/MapSearch";
import MeterShifting from "./MeterShifting";

export default {
  name: "Meter",
  components: {MeterShifting, MapSearch, ErpTreeStatusV2, UploadFilesSysc, ErpTree},
  data() {
    return {
      modal1:false,
      host_url: "",
      keyword: '',
      loading: false,
      param: {
        level:"",
        meter_type: "",
        house_name: "",
        number: "",
        charging_standard: "",
        status: "",
        status_ids: [1,2],
        line: "",
        meter_nature: "",
        energys: [1,2,3,4],
        meter_nature_ids: [1,2,3,4],
        name: "",
        type:"",
        id:"",
      },
      pageData: {
        data: [],
        total: 0,
        per_page: 15,
        page: 1
      },
      countData:{
        house_count:'',
        meter_type_count:'',
      },
      dialogVisible: false,
      treeDialogVisible: false,
      form: {
        pid:'',
        name: "",
        number: "",
        project_id: "",
        house_id: "",
        house_name: "",
        house_number: "",
        meter_number: "",
        meter_type: "",
        charge_type: "",
        charging_standard: "",
        sort: "0",
        status: 1,
        meter_nature: 1,
        magnification: 1,
        start_number: 0,
        return_trip: "",
        install_time: "",
        reading_time: "",
        position: "",
        lat: "",
        lng: "",
        files: "",
        line: "",
        specifications: "",
        remarks: "",
        is_update:0,
        energys:"1",
        energy_nature:"1",
      },
      update_form: {
        pid:'',
        name: "",
        number: "",
        project_id: "",
        house_id: "",
        house_name: "",
        house_number: "",
        meter_number: "",
        meter_type: "",
        charge_type: "",
        charging_standard: "",
        sort: "0",
        status: 1,
        meter_nature: 1,
        magnification: 1,
        start_number: 0,
        return_trip: "",
        install_time: "",
        reading_time: "",
        position: "",
        lat: "",
        lng: "",
        files: "",
        line: "",
        specifications: "",
        remarks: "",
        is_update:1,
        end_number:"",
        meter_update_time:"",
        end_use:"",
        admin_name:"",
        admin_id:"",
        energys:"1",
      },
      uploadUrl: "",
      month_value: "",
      business_list: [],
      entry_type_name: "",
      multipleSelection: [],
      meter_type_list: [],
      house_charge_list:[],
      chargeItem_name_ids:"",
      meter_nature_list:[{name:'分表',val:1},{name:'总表',val:2},{name:'分摊表',val:3},{name:'电力负荷表',val:4}],
      charging_standard:"",
      mapDialogTableVisible:false,
      updateDialogVisible:false,
      yDialogVisible:false,
      mapCenter:[0,0],
      energyArray:{
        id:'',
        number:'',
        name:'',
        meter_type:'',
        meter_nature:'',
        energys:'',
        energy_nature:'',
      },
    }
  },
  created() {
    this.host_url = __HTTP__.defaults.baseURL;
    this.getMeterTypeList()
  },
  watch: {
    dialogVisible(val) {
      if (val == false) {
        // this.fileList = []
      }
    },
    "form.meter_nature"(val){
      if(this.form.meter_nature == 3){
        this.form.energys = "3";
      }else{
        this.form.energys = "1";
      }
      this.form.energy_nature = '';

    },
    "form.energys"(val){
      this.form.energy_nature = '';
    },
    "form.project_id":function (n) {
      this.getHouseChargeList();
    },
    "form.meter_type":function (n) {
      this.chargeItem_name_ids=(this.meter_type_list.find(ret=>{ return ret.id===n })||{}).expenditure_ids||"";
      this.getHouseChargeList();
    },
    "param.meter_type":function (n) {
      this.chargeItem_name_ids=(this.meter_type_list.find(ret=>{ return ret.id===n })||{}).expenditure_ids||"";
      this.getHouseChargeList();
    }
  },
  computed: {
    multipleSelection_meter_type_num(){
      let set=new Set();
      this.multipleSelection.map(ret=>{
        set.add(ret.meter_type)
      });
      return Array.from(set).length;
    }
  },
  methods: {
    getFormData(data) {
      return Object.assign({
        pid:'',
        name: "",
        number: "",
        project_id: "",
        house_id: "",
        house_name: "",
        house_number: "",
        meter_number: "",
        meter_type: "",
        charge_type: "",
        charging_standard: "",
        sort: "0",
        status: 1,
        meter_nature: 1,
        magnification: 1,
        start_number: 0,
        return_trip: "",
        install_time: "",
        reading_time: "",
        position: "",
        lat: "",
        lng: "",
        files: "",
        line: "",
        specifications: "",
        remarks: "",
        is_update:0,
        energys:"1",
        energy_nature:"1",
      }, data)
    },
    search() {
      this.pageData.page = 1
      this.getList()
    },
    getList() {
      var that = this;
      that.loading = true;
      var search = this.param;
      search.page = this.pageData.page
      search.pageSize = this.pageData.per_page
      search.routeType = 2

      ERP.getRequest({
        url: "admin/Meter/managerGetList",
        data: search
      }, res => {
        if (res.code) {
          that.pageData = res.data.data
          that.countData.house_count = res.data.house_count
          that.countData.meter_type_count = res.data.meter_type_count
        }
        that.loading = false;
        that.multipleSelection = []
      })
    },
    energysbol(){
      ERP.showLoading()
      this.$myhttp.post('admin/Meter/energys',this.energyArray,{
        'Content-Type': 'application/x-www-form-urlencoded'
        }).then(backdata=>{ // 异步执行成功后
          ERP.hideLoading()
          this.$Message.success(backdata.data.message);
          this.getList()
      });
    },
    meterShifting(item) {
      this.$refs.MeterShifting.show(reObject(item))
    },
    submitForm() {
      var that = this;
      that.formLoading = true
      let data = Object.assign({}, this.form)

      ERP.postRequest({url: "admin/Meter/save", data: data}, res => {
        that.$message({type: res.code === 1 ? 'success' : 'error', message: res.msg})
        if (res.code) {
          that.dialogVisible = false
          that.getList()
        }
        that.formLoading = false
      })
    },

    updateSubmitForm() {
      var that = this;
      that.formLoading = true
      //原仪表
      let update_form = Object.assign({}, this.update_form)
      update_form.is_update=1;
      ERP.postRequest({url: "admin/Meter/save", data: update_form}, res => {
        if (res.code) {
          //新仪表
          let form = Object.assign({}, this.form)
          form.pid=form.id;
          form.id=undefined;
          form.meter_update_time="";
          form.end_use="";
          form.end_number="";

          ERP.postRequest({url: "admin/Meter/save", data: form}, res => {
            that.$message({type: res.code === 1 ? 'success' : 'error', message: res.msg})
            if (res.code) {
              that.updateDialogVisible = false
              that.getList()
            }
            that.formLoading = false
          })
        }
      })
    },

    setFrom(data){
      var that = this;
      ERP.postRequest({url: "admin/Meter/save", data: data}, res => {
        that.$message({type: res.code === 1 ? 'success' : 'error', message: res.msg})
        if (res.code) {
          that.getList()
        }
      })
    },
    handleSelectionChange(val) {
      console.log(val)
      this.multipleSelection = val;
    },
    shoeTreeDialogVisible() {
      this.treeDialogVisible = true;
    },
    nodeClick2(data) {
      let tree_str = data.tree.map(ret => {
        return ret.name
      }).join('->');
      //console.log(data);
      this.form.project_id = data.tree[0].pindex_id;
      this.form.house_name = tree_str;
      this.form.house_id = data.tree[data.tree.length - 1].house_id;
    },
    nodeClick(data) {
      let tree_str = data.tree.map(ret => {
        return ret.name
      }).join('->');

      if(this.type != 'zone'){
        this.form.type = data.type;
        this.form.project_id = data.tree[0].pindex_id;
        this.form.house_name = tree_str;
        this.form.house_id = data.tree[data.tree.length - 1].house_id;
        this.param.house_name=tree_str;
      }

      this.param.type = data.type
      this.param.id = data.id
      this.getList();
    },
    getMeterTypeList(){
      var that=this;
      let param={};
      ERP.getRequest({
        url:"admin/MeterType/getList",
        data:{
          param:JSON.stringify(param),
          field:"id,name,expenditure_ids,expenditure_name",
          page: 1,
          page_size: 200
        }
      },ret=>{
        if(ret.code){
          that.meter_type_list=ret.data.list;
        }
      })
    },
    getHouseChargeList(){
      var that=this;
      let param={};
      this.form.project_id&&(param.pindex_id=this.form.project_id);
      this.chargeItem_name_ids&&(param.chargeItem_name_ids=this.chargeItem_name_ids);
      ERP.getRequest({
        url:"admin/HouseCharge/getList",
        data:{
          param:JSON.stringify(param),
          page: 1,
          page_size: 200
        }
      },ret=>{
        if(ret.code){
          that.house_charge_list=ret.data.list;
        }
      })
    },
    showMapDialogTableVisible(){
      this.mapDialogTableVisible=true
    },
    navToMeterExcel(){
      ERP.navigateTo("/SecpMeter/meterExcel");
    },
    showLine(){
      ERP.navigateTo("/SecpMeter/lineStructure");
    }
  }
}

function reObject(item) {
  return JSON.parse(JSON.stringify(item));
}
</script>
<style lang="scss" scoped>

.el-button--primary, .el-button--danger, .el-button--success, .el-button--warning {
  color: #fff;
}


.check-work-body {
  padding: 15px;
  width: 98%;
}

.search-wrap {
  padding-bottom: 15px;
  border-bottom: 1px solid #EBEEF5;
}

.table-wrap {
  margin-top: 5px;
  //height: calc(70vh) !important;
  //overflow: auto !important;
}

.pagination-wrap {
  display: flex;
  justify-content: center;
  margin-top: 15px;
}


.check-work-tb {
  border-collapse: collapse;

  td, th {
    border: 1px solid #EBEEF5;
    line-height: 20px;
    padding: 10px 10px;
    font-size: 12px;
  }

  th {
    font-weight: bold;
    text-align: left;
  }
}

.el-calendar-table .el-calendar-day {
  height: 50px;
}

.check-work-class-editor {
  margin-top: 10px;
  .cw-header {
    width: 100%;
    display: table;
    border-collapse: collapse;

    .cw-title {
      display: table-cell;
      border: 1px solid #EBEEF5;
      padding: 5px 10px;
      line-height: 20px;
      font-weight: bold;

      &.cw-name {
        width: 100px;
      }

      &.cw-class {
        flex: 1;
      }
    }

  }

}

.d-flex {
  display: flex;
}

.d-flex-left {
  margin-right: 10px;
  border-right: 1px solid #eee;
  padding-right: 10px;
}

.d-flex-right {
  flex: 1;
  overflow-x:hidden;
}

.form-input {
  width: 100%;
}

.table-wrap {
  width: calc(100vw - 450px);
  overflow-x: scroll;
}
.amap-box{
  width: 500px;
  height: 500px;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/SecpMeter/Meter.vue